import { SectionTarifsWrapper } from "./SectionTarifs.style";
import { useState } from "react";
import { Button, Switch, Collapse, Dropdown, Menu } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { useMediaQuery } from "react-responsive";

export default function SectionTarifs() {
  const [isMensuel, setIsMensuel] = useState(true);
  const { Panel } = Collapse;
  const isDesktop = useMediaQuery({ minWidth: 1024 });

  const pricings = [
    {
      title: "Agrégation globale",
      checks: [true, true, true],
      fonctionnalities: {
        "Agrégation de vos comptes": {
          title: "Permet de suivre vos comptes externes en un seul endroit",
          checks: [true, true, true],
        },
        "Ajout de votre patrimoine": {
          title: "Permet d'ajouter vos biens immobiliers",
          checks: [true, true, true],
        },
        "Suivi de votre famille": {
          title: "Permet d'avoir une vision globale de la famille",
          checks: [true, true, true],
        },
      },
    },
    {
      title: "Analyse",
      checks: [true, true, true],
      fonctionnalities: {
        "Analyse fiscale": {
          title:
            "Permet de calculer l'impôt et l'impact fiscal de chaque revenu",
          checks: [true, true, true],
        },
        "Analyse diversification": {
          title: "Permet d'avoir une vision globale de vos actifs",
          checks: [true, true, true],
        },
        "Calcul du risque": {
          title: "Permet de connaitre le risque moyen de son patrimoine",
          checks: [true, true, true],
        },
        "Evolution de vos actifs": {
          title: "Permet de suivre l'évolution passée de votre patrimoine",
          checks: [true, true, true],
        },
        "Rendement de vos actifs": {
          title:
            "Permet de connaitre la rentabilité passée de vos investissements - renta d'un bien immo avec crédit sans crédit",
          checks: [false, true, true],
        },
        "Estimer ma retraite": {
          title: "Permet de faire une estimation de la retraite",
          checks: [false, true, true],
        },
        "Estimation besoin de trésorerie": {
          title:
            "Permet de calculer mon besoin de trésorerie mensuelle sans le prêt RP et sans les enfants",
          checks: [false, true, true],
        },
        "Estimation droits de succession": {
          title:
            "Permet de calculer les droits de succession dans la situation actuelle",
          checks: [false, false, true],
        },
        "Estimation de mon taux d'endettement": {
          title:
            "Permet de calculer l'endettement que chaque actif représente au global",
          checks: [false, false, true],
        },
      },
    },
    {
      title: "Alertes",
      checks: [true, true, true],
      fonctionnalities: {
        "Renégocier vos taux de prêts": {
          title: "",
          checks: [true, true, true],
        },
        "Renégocier vos assurances emprunteurs": {
          title: "",
          checks: [true, true, true],
        },
        "Estimation coût décès": {
          title:
            "Permet de connaitre l'impact d'un décès (coût & part destinée à chaque héritier)",
          checks: [false, true, true],
        },
        "Rentabilité d'un investissement immobilier": {
          title: "Permet de connaitre le rendement de votre actif immobilier",
          checks: [false, true, true],
        },
        "Rentabilité d'un investissement financier": {
          title: "Permet de connaitre le rendement de votre actif financier",
          checks: [false, false, true],
        },
        "Risque financier": {
          title:
            "Permet d'afficher une baisse supérieure à 10% d'un actif (notamment financier)",
          checks: [true, true, true],
        },
        "Risque diversification": {
          title: "Permet de mettre en avant un biais diversication",
          checks: [true, true, true],
        },
      },
    },
    {
      title: "Projections",
      checks: [false, true, true],
      fonctionnalities: {
        "Investissement immobilier": {
          title: "Simulation d'investissement - Calcul TRI",
          checks: [false, true, true],
        },
        "Investissement financier": {
          title: "Simulation d'investissement - Calcul TRI",
          checks: [false, true, true],
        },
        "Donation entre époux": {
          title: "Affichage graphique des avantages / inconvénients",
          checks: [false, true, true],
        },
        "Donation aux enfants": {
          title: "Calcul économie / optimisation offerte",
          checks: [false, true, true],
        },
        "Acheter ou louer": { title: "", checks: [false, true, true] },
        "Où placer X €": { title: "", checks: [false, true, true] },
        "Mariage / Pacs / Divorce": { title: "", checks: [false, true, true] },
      },
    },
    {
      title: "Gestion des documents",
      checks: [false, false, true],
      fonctionnalities: {
        "Affectation d'une dépense à un bien": {
          title: "Simplifie le suivi dans le temps de toute ses opérations",
          checks: [false, false, true],
        },
      },
    },
    {
      title: "Aide comptable",
      checks: [false, false, true],
      fonctionnalities: {
        "Affectation d'une dépense à un bien": {
          title:
            "Si agrégation de votre compte, permet d'affecter une dépense à un bien avec ajout du document justificatif",
          checks: [false, false, true],
        },
        "Préparation de votre déclaration": {
          title: "Permet de sauvergarder les calculs liés à votre déclaration",
          checks: [false, false, true],
        },
      },
    },
    {
      title: "Aide financement",
      checks: [false, true, true],
      fonctionnalities: {
        "Générer votre présentation d'investissement": {
          title: "Permet d'aider à trouver le meilleur crédit par soi même",
          checks: [false, true, true],
        },
      },
    },
    {
      title: "Partage",
      checks: [false, false, true],
      fonctionnalities: {
        "Partage tout ou partie avec un expert": {
          title:
            "Permet de donner accès (temporaire) à tout ou partie de sa situation à son expert, notaire, comptable, avocat etc",
          checks: [false, false, true],
        },
      },
    },
    {
      title: "Support",
      checks: [true, true, true],
      fonctionnalities: {
        "Souscription assistée par un conseiller": {
          title: "",
          checks: [true, true, true],
        },
        "Conseiller dédié": { title: "", checks: [false, true, true] },
        "Support prioritaire": { title: "", checks: [false, true, true] },
      },
    },
  ];

  return (
    <SectionTarifsWrapper>
      <div className="isMensuelWrapper">
        <Switch
          checkedChildren="Mensuel"
          unCheckedChildren="Annuel"
          defaultChecked
          onChange={(isMensuel) => setIsMensuel(isMensuel)}
        />
        {isMensuel ? (
          <span>Economisez deux mois en passant à l'abonnement annuel</span>
        ) : (
          <span>
            2 mois offerts <br />
          </span>
        )}
      </div>

      <Collapse accordion>
        <div className="pricingCollapseHeader">
          <div className="features">
            <p>Fonctionnalités</p>
          </div>
          <div className="basic">
            <p>Basique</p>
            <p className="description">
              {/* <p className="description">0€ / {isMensuel ? "mois" : "an"}</p> */}
              {isDesktop && "Prochainement..."}
            </p>
          </div>
          <div className="essential">
            <p>Essentielle</p>
            <p className="description">
              {/* {isMensuel ? "7" : "70"}€ / {isMensuel ? "mois" : "an"} */}
              {isDesktop && "Prochainement..."}
            </p>
          </div>
          <div className="premium">
            <p>Premium</p>
            <p className="description">
              {/* {isMensuel ? "12" : "120"}€ / {isMensuel ? "mois" : "an"} */}
              {isDesktop && "Prochainement..."}
            </p>
          </div>
        </div>
        {pricings.map((pricing, index) => {
          return (
            <Panel
              header={
                <>
                  <div className="features">
                    <p>{pricing.title}</p>
                  </div>
                  {pricing.checks.map((check, index) => {
                    return (
                      <div className="check" key={index}>
                        {check ? (
                          <FontAwesomeIcon icon={faCheckCircle} />
                        ) : (
                          <FontAwesomeIcon icon={faTimesCircle} />
                        )}
                      </div>
                    );
                  })}
                </>
              }
            >
              {Object.entries(pricing.fonctionnalities).map(
                ([title, details], i) => {
                  return (
                    <span key={i}>
                      <div className="features">
                        <Dropdown
                          overlay={
                            details.title ? (
                              <Menu>
                                <Menu.Item>{details.title}</Menu.Item>
                              </Menu>
                            ) : (
                              <></>
                            )
                          }
                        >
                          <p>{title}</p>
                        </Dropdown>
                      </div>
                      {details.checks.map((check, i) => {
                        return (
                          <div className="check" key={i}>
                            {check ? (
                              <FontAwesomeIcon icon={faCheckCircle} />
                            ) : (
                              <FontAwesomeIcon icon={faTimesCircle} />
                            )}
                          </div>
                        );
                      })}
                    </span>
                  );
                }
              )}
            </Panel>
          );
        })}
      </Collapse>
    </SectionTarifsWrapper>
  );
}
